import styled, { css } from 'styled-components';
import React from 'react';
import { NavLink } from 'react-router-dom';
import Loader from '../../loader/Loader';

// eslint-disable-next-line jsx-a11y/anchor-has-content
export const StyledLink = styled(({ to, external, ...props }) => external ? <a href={to} {...props} /> : <NavLink to={to} relative="path" {...props} />)`
  position: relative;
  display: flex;
  text-decoration: none;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
  border: 0;
  border-bottom: ${({ theme }) => theme.SideNavLink.borderBottom};
  border-left: 3px solid ${({ theme }) => theme.SideNavLink.background};
  background: ${({ theme }) => theme.SideNavLink.background};
  padding: ${({ theme }) => theme.SideNavLink.padding};
  outline: none;
  line-height: ${({ theme }) => theme.SideNavLink.lineHeight};
  box-sizing: border-box;
  // When the link is actually a button
  width: 100%;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.SideNavLink.hoverBackground};
    color: ${({ theme }) => theme.colors.blue5};
    border-left: 3px solid ${({ theme }) => theme.SideNavLink.hoverBackground};
  }

  &:focus-visible:not([disabled]), &:focus:not([disabled]) {
    box-shadow: ${({ theme }) => theme.boxShadows?.focus};
  }

  &:focus:not(&:focus-visible) {
    box-shadow: none;
  }

  &:focus {
    position: relative;
    z-index: 1;
    background: ${({ theme }) => theme.SideNavLink.focusBackground};
    color: ${({ theme }) => theme.colors.primary};
  }

  &.active {
    border-left: 3px solid ${({ theme }) => theme.colors.blue5};
    color: ${({ theme }) => theme.colors.blue5};
  }

  &:active:not(:disabled) {
    background: ${({ theme }) => theme.SideNavLink.activeBackground};
    color: ${({ theme }) => theme.colors.blue10};
    border-left: 3px solid ${({ theme }) => theme.SideNavLink.activeBackground};
  }
  &:active:not(:disabled).active {
    border-left: 3px solid ${({ theme }) => theme.colors.blue5};
  }

  ${({ disabled }) => disabled && css`
    cursor: default;
  `}
`;

export const StyledLinkText = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  padding-right: 8px;
`;

export const StyledLoaderWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
`;

export const StyledLoader = styled(Loader)`
  position: absolute;
  top: 8px;
  left: 0;
`;
